import React from "react";
import { motion } from "framer-motion";
import araaa from "../../accests/galle/tur.jpg";
import gal from "../../accests/galle/galle (1).jpeg";
import sin from "../../accests/sinharaja/sinha (5).jpeg";
import yaa from "../../accests/yala/leopardImg.jfif";
import uh from "../../accests/udawalawa/udaaa.jpg";
import nine from "../../accests/ella/ella.jpeg";
import rawanas from "../../accests/ella/rawana.jpeg";
import ee from "../../accests/ella/ee.jpeg";
import tem from "../../accests/kan/kan (3).jpeg";
import pas from "../../accests/common/pas.jpeg";
import sss from "../../accests/common/sss.jpeg";
// import paa from "../accests/paa.jpeg";
import ruwan from "../../accests/common/ruwan.jpeg";
import dam from "../../accests/sigiri/sigiri (1).jpeg";
import pis from "../../accests/pinna/pis.jpeg";

const dayHighlights = [
    {
        day: "Day 1 – Arrival",
        title: "Kosgoda & Bentota",
        desc: "Visit the Kosgoda Turtle Hatchery to learn about sea turtle conservation and watch baby turtles make their way to the sea. Enjoy a peaceful Bentota River Safari amidst lush mangroves and spot wildlife like water monitors, crocodiles, and exotic birds.",
        img: araaa,
    },
    {
        day: "Day 2 – Kosgoda & Galle",
        title: "Galle Fort, Stilt Fishing & Moonstone Mine",
        desc: "Explore the UNESCO-listed Dutch Fort of Galle, watch stilt fishermen in Koggala, visit local moonstone mines, and understand the island’s gem heritage. Conclude with a visit to the Tsunami Museum to learn about the 2004 disaster and recovery efforts.",
        img: gal,
    },
    {
        day: "Day 3 – Sinharaja & Udawalawe",
        title: "Rainforest Trek & Elephant Transit Home",
        desc: "Trek through Sinharaja Rainforest, spotting endemic birds and rare reptiles. Visit Udawalawe Elephant Transit Home to see orphaned elephants being rehabilitated and enjoy interactive experiences with baby elephants.",
        img: sin,
    },
    {
        day: "Day 4 – Udawalawe & Yala",
        title: "Safari Adventures",
        desc: "Experience Udawalawe National Park with large elephant herds and diverse wildlife. Continue to Yala National Park for leopards, elephants, buffaloes, and exotic birds. Enjoy guided safari routes for optimal wildlife sightings.",
        img: uh,
    },
    {
        day: "Day 5 – Yala",
        title: "Second Safari",
        desc: "Go deeper into Yala National Park for another chance to explore its diverse ecosystems, from grasslands to forested areas. Spot elusive leopards and other wildlife in one of the world’s best leopard habitats.",
        img: yaa,
    },
    {
        day: "Day 6 – Ella",
        title: "Nine Arches Bridge & Mini Adams Peak",
        desc: "Visit the iconic Nine Arches Bridge and hike Mini Adams Peak for breathtaking valley views. Enjoy lush tea plantations and cascading waterfalls along the way.",
        img: nine,
    },
    {
        day: "Day 7 – Relax in Ella",
        title: "Free Day",
        desc: "Relax and explore Ella at your own pace. Optional visits include Ravana Falls, local tea plantations, or simply enjoying the peaceful highland ambiance.",
        img: rawanas,
    },
    {
        day: "Day 8 – Ella to Nuwara Eliya",
        title: "Scenic Train Journey & Tea Plantation",
        desc: "Take the scenic train ride from Ella to Nuwara Eliya, passing lush tea plantations and misty hills. Visit a tea plantation, learn about tea production, and explore Nuwara Eliya city with colonial architecture and gardens.",
        img: ee,
    },
    {
        day: "Day 9 – Kandy",
        title: "Spice Garden & Temple of the Tooth Relic",
        desc: "Visit a local Hindu temple and spice garden in Matale. Witness a cultural dance show in Kandy, and explore the sacred Temple of the Tooth Relic.",
        img: tem,
    },
    {
        day: "Day 10 – Veddahs & Passikudah",
        title: "Indigenous Village & Beach",
        desc: "Meet the indigenous Veddah people, learning about their traditional lifestyle. Continue to Passikudah Beach for a relaxing tropical escape along calm, golden sands.",
        img: sss,
    },
    {
        day: "Day 11 – Passikudah",
        title: "Beach Day",
        desc: "Enjoy a full day at Passikudah Beach, swimming, sunbathing, or partaking in water sports such as snorkeling, diving, or kayaking.",
        img: pas,
    },
    {
        day: "Day 12 – Passikudah, Trincomalee, Mihintale & Anuradhapura",
        title: "Cultural & Historical Exploration",
        desc: "Visit Fort Frederick in Trincomalee, Mihintale for Buddhist heritage, and the ancient city of Anuradhapura, including the Ruwanwelisaya Stupa and sacred Bodhi tree.",
        img: sss,
    },
    {
        day: "Day 13 – Anuradhapura",
        title: "Ancient Ruins",
        desc: "Explore Anuradhapura’s ancient ruins, including Abhayagiri Monastery and other key archaeological and historical sites.",
        img: ruwan,
    },
    {
        day: "Day 14 – Sigiriya & Dambulla",
        title: "Lion Rock & Cave Temples",
        desc: "Visit Sigiriya Rock Fortress and Dambulla Cave Temples, UNESCO World Heritage Sites with ancient frescoes, gardens, and over 150 Buddha statues.",
        img: dam,
    },
    {
        day: "Day 15 – Pinnawala & Departure",
        title: "Elephant Orphanage & Negombo Beach",
        desc: "Watch elephants at Pinnawala Elephant Orphanage and spend your last day relaxing at Negombo Beach before your transfer to Colombo Airport.",
        img: pis,
    },
];

const info = [
    { label: "Trip Length", value: "15 Days" },
    { label: "Language", value: "English" },
    { label: "Best Time to Travel", value: "Year-round" },
    { label: "Transfers", value: "Hotel – Tour Attractions – Hotel" },
];

const inclusions = [
    "Air-conditioned private transport: Car, Van, or Luxury Bus",
    "Accommodation in good-quality hotels, villas, and resorts on a Half Board basis",
    "Professional English-speaking guides",
    "Entrance fees to all UNESCO Heritage Sites and safari activities",
    "Unlimited mineral water throughout the tour",
    "All government taxes and tariffs included",
];

const exclusions = [
    "Additional meals & beverages beyond the meal plan",
    "Visa and flight bookings",
    "Personal expenses, tips, and portage",
];

const travelTips = [
    "Bring comfortable light clothing, swimwear, sunscreen, and insect repellent",
    "Hat and passport are essential",
    "Dress modestly when visiting religious sites (shoulders and knees covered)",
    "Always carry extra money for personal expenses, tips, and gratuities",
];

export default function SummerTour() {

    return (


        <div className="overflow-x-hidden">
            {/* Hero Section */}
            <section className="relative h-[70vh] w-full overflow-hidden">
                <img
                    src={ruwan}
                    alt="Summer Tour Sri Lanka"
                    className="w-full h-full object-cover"
                />
                <div
                    className="absolute inset-0 bg-gradient-to-b from-black/60 to-black/40 flex flex-col items-center justify-center text-center px-4">
                    <h1 className="text-4xl md:text-5xl text-white font-bold mb-3">
                        Summer Tour – Discover Sri Lanka
                    </h1>
                    <p className="text-lg md:text-xl text-white/90 max-w-3xl">
                        15-Day immersive journey exploring adventure, culture, nature & beaches
                    </p>
                </div>
            </section>


            <div className="max-w-7xl mx-auto px-4 py-16 space-y-16">
            {/* Day Highlights */}
            <section data-aos="fade-up"
                     data-aos-duration="3000" className="space-y-12">
                {dayHighlights.map((item, idx) => (
                    <motion.div
                        key={idx}
                        initial={{opacity: 0, x: idx % 2 === 0 ? -50 : 50}}
                        whileInView={{opacity: 1, x: 0}}
                        viewport={{once: true}}
                        className={`md:flex md:items-center md:space-x-8 bg-white shadow-lg rounded-xl overflow-hidden ${
                            idx % 2 === 1 ? "md:flex-row-reverse" : ""
                        }`}
                    >
                        <img
                            src={item.img}
                            alt={item.title}
                            className="md:w-1/2 h-64 object-cover"
                        />
                        <div className="p-6 md:w-1/2">
                            <h3 className="text-2xl font-bold mb-2">{item.day}</h3>
                            <h4 className="text-xl font-semibold mb-4">{item.title}</h4>
                            <p className="text-gray-700">{item.desc}</p>
                        </div>
                    </motion.div>
                ))}
            </section>

            {/* Info Section */}
            <section data-aos="fade-up"
                     data-aos-duration="3000"
                     className="bg-yellow-50 p-8 rounded-xl shadow-lg grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {info.map((item, idx) => (
                    <div key={idx} className="text-center">
                        <h4 className="text-lg font-semibold">{item.label}</h4>
                        <p className="text-gray-700">{item.value}</p>
                    </div>
                ))}
            </section>

            {/* Inclusions & Exclusions */}
            <section data-aos="fade-up"
                     data-aos-duration="3000" className="grid md:grid-cols-2 gap-8">
                <div className="bg-white p-6 rounded-xl shadow-lg">
                    <h3 className="text-2xl font-bold mb-4">Tour Inclusions</h3>
                    <ul className="list-disc list-inside space-y-2 text-gray-700">
                        {inclusions.map((i, idx) => (
                            <li key={idx}>{i}</li>
                        ))}
                    </ul>
                </div>
                <div className="bg-white p-6 rounded-xl shadow-lg">
                    <h3 className="text-2xl font-bold mb-4">Tour Exclusions</h3>
                    <ul className="list-disc list-inside space-y-2 text-gray-700">
                        {exclusions.map((e, idx) => (
                            <li key={idx}>{e}</li>
                        ))}
                    </ul>
                </div>
            </section>

            {/* Travel Tips */}
            <section data-aos="fade-up"
                     data-aos-duration="3000" className="bg-gray-50 p-6 rounded-xl shadow-lg">
                <h3 className="text-2xl font-bold mb-4">Travel Tips</h3>
                <ul className="list-disc list-inside space-y-2 text-gray-700">
                    {travelTips.map((tip, idx) => (
                        <li key={idx}>{tip}</li>
                    ))}
                </ul>
            </section>

            {/* WhatsApp CTA */}
            <motion.div
                initial={{opacity: 0, y: 40}}
                whileInView={{opacity: 1, y: 0}}
                transition={{duration: 0.8}}
                className="mt-14 text-center"
            >
                <motion.a
                    whileHover={{scale: 1.08}}
                    whileTap={{scale: 0.95}}
                    href="https://wa.me/94770163670?text=Hello%20I%20would%20like%20to%20book%20the%2015-Day%20Sri%20Lanka%20Summer%20Tour.%20Please%20share%20availability%20and%20pricing.%20Thank%20you."
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center px-14 py-4 bg-green-600 text-white font-semibold text-lg rounded-full shadow-xl hover:bg-green-500 transition-all duration-300"
                >
                    Book This Tour
                </motion.a>
                <p className="mt-4 text-sm text-gray-600">
                    💬 Instant WhatsApp Support • 🌴 Adventure, Culture & Beaches • 🚙 Comfortable Private Transport
                </p>
            </motion.div>
        </div>
        </div>
    );
}
